import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { combineReducers } from 'redux'

import userReducer from './slices/user'
import activityCategoriesReducer from './slices/activityCategories'
import activityTypesReducer from './slices/activityTypes'
import sidebarSlidersReducer from './slices/sidebarSliders'
import activityReducer from './slices/activity'
import sidebarReducer from './slices/sidebar'
import formDetailsReducer from './slices/formDetails'
import userActivityReducer from './slices/userActivity'
import previewReducer from './slices/preview'
import duonutSettingsReducer from './slices/duonutSettings'

const reducer = combineReducers({
    user: userReducer,
    activityCategories: activityCategoriesReducer,
    activityTypes: activityTypesReducer,
    sidebarSliders: sidebarSlidersReducer,
    activity: activityReducer,
    sidebar: sidebarReducer,
    formDetails: formDetailsReducer,
    userActivity: userActivityReducer,
    preview: previewReducer,
    duonutSettings: duonutSettingsReducer
})

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})



setupListeners(store.dispatch)